import type { ReactNode } from "react"
import { Box, Typography } from "@mui/material"

interface MetaItemProps {
  label: string
  children: ReactNode
}

/** One attribute in an asset header's metadata line: the label muted, the value bright. */
const MetaItem = ({ label, children }: MetaItemProps) => (
  // On mobile the label and the value become the two columns of the list's grid.
  <Typography component="div" sx={{ display: { xs: "contents", md: "block" } }}>
    <Box component="span" color="text.secondary">
      {label}:
    </Box>{" "}
    <Box component="span" color="text.primary">
      {children}
    </Box>
  </Typography>
)

/** The metadata line: one row that wraps on desktop, a key and value grid on mobile. */
export const MetaList = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      display: { xs: "grid", md: "flex" },
      gridTemplateColumns: "max-content 1fr",
      flexWrap: "wrap",
      columnGap: 2,
      rowGap: 0.5,
    }}
  >
    {children}
  </Box>
)

export default MetaItem
